import { RecoveryServiceImpl } from "./recovery-service";
import app from "../../sdAppModule";

app.service("recoveryService", RecoveryServiceImpl);
